import React, { ComponentProps, FC, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import CheckBox from '~/components/atoms/CheckBox';
import detectBrowser from '~/libs/detectBrowser';
import { RootReducerState } from '~/modules';
import { manageFCMAction } from '~/modules/ManageFCMModule';

type PushSettingHandleType = ComponentProps<typeof CheckBox>['onChange'];

enum IconClassName {
    CHROME = 'chrome',
    FIREFOX = 'firefox',
    EDGE = 'edge',
    WHALE = 'whale',
    SAFARI = 'safari',
    OPERA = 'opera'
}

const SettingArea: FC = () => {
    const dispatch = useDispatch();

    const enabled = useSelector<RootReducerState, boolean>(
        ({ manageFCMReducer }) => manageFCMReducer.data.enabled
    );

    // push setting 변경 시 enabled 변경
    const handleChangePushSetting: PushSettingHandleType = (event) => {
        dispatch(
            manageFCMAction.updateEnabledWithPermission(
                event.currentTarget.checked
            )
        );
    };

    // 브라우저 icon class name
    const className = useMemo(() => {
        const info = detectBrowser();
        if (!info) return IconClassName.CHROME;

        switch (info.name) {
            case 'firefox':
                return IconClassName.FIREFOX;

            case 'edge':
            case 'edge-chromium':
            case 'edge-ios':
                return IconClassName.EDGE;

            case 'whale':
                return IconClassName.WHALE;

            case 'safari':
                return IconClassName.SAFARI;

            case 'opera':
            case 'opera-mini':
                return IconClassName.OPERA;

            case 'chrome':
            default:
                return IconClassName.CHROME;
        }
    }, []);

    return (
        <div className="settingPush">
            <dl className={className}>
                <dt>
                    <Trans>이 브라우저에서 알림 받기</Trans>
                </dt>
                <dd>
                    <CheckBox
                        checked={enabled}
                        onChange={handleChangePushSetting}>
                        <Trans>설정/해제</Trans>
                        <i />
                    </CheckBox>
                </dd>
            </dl>
        </div>
    );
};

export default SettingArea;
